import React, { useState } from "react";
import { Button, Form, Input } from "reactstrap";
import { useNavigate } from "react-router-dom";

import logo from "../../assets/img/Logo-png.svg";
import { adminforgotpassword } from "../../api/ApiServices";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    const cleanEmail = email.trim();

    if (!cleanEmail) {
      setErrorMsg("Please enter your email address.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(cleanEmail)) {
      setErrorMsg("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    try {
      const response = await adminforgotpassword({ email: cleanEmail });

      // Direct redirect without popup
      if (response?.success === true) {
        navigate("/auth/verify-otp", {
          state: {
            email: cleanEmail,
          },
        });
        return;
      }

      setErrorMsg(response?.message || "Unable to send OTP. Please try again.");
    } catch (error) {
      const status = error?.response?.status;
      let message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Something went wrong. Please try again.";

      if (status === 404) {
        message = "No account found with this email address. Please check and try again.";
      } else if (status === 403) {
        message = "Your account is inactive. Please contact support.";
      } else if (status === 400) {
        message = "Invalid email format. Please check and try again.";
      } else if (status === 500) {
        message = "Server error. Please try again later.";
      }

      setErrorMsg(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-card">
      {/* Header with Logo and Step Badge */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <img src={logo} alt="Area Trek" style={{ height: "36px", maxWidth: "130px", objectFit: "contain" }} />
        <span
          style={{
            background: "#eff6ff",
            color: "#0356BB",
            fontSize: "0.75rem",
            fontWeight: "700",
            padding: "4px 12px",
            borderRadius: "20px",
            border: "1px solid #dbeafe",
            whiteSpace: "nowrap",
          }}
        >
          STEP 1 / 3
        </span>
      </div>

      {/* Key Emblem */}
      <div className="text-center my-3">
        <div
          style={{
            width: "56px",
            height: "56px",
            borderRadius: "16px",
            background: "#eff6ff",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#0356BB",
            fontSize: "1.4rem",
            border: "1px solid #bfdbfe",
          }}
        >
          <i className="fas fa-key"></i>
        </div>
      </div>

      <h2
        className="text-center font-weight-bold mb-1"
        style={{ color: "#111827", fontSize: "1.45rem" }}
      >
        Forgot Password
      </h2>

      <p
        className="text-center text-muted mb-4"
        style={{ fontSize: "0.88rem", lineHeight: "1.5" }}
      >
        Enter your admin email to receive a 6-digit verification code.
      </p>

      <Form onSubmit={handleSubmit}>
        <div className="custom-form-group">
          <label className="custom-label" style={{ color: "#4b5563" }}>
            Admin Account Email
          </label>

          <div
            className="custom-input-group"
            style={{
              borderColor: errorMsg ? "#f5365c" : "",
            }}
          >
            <i className="far fa-envelope" style={{ color: "#0356BB" }}></i>
            <Input
              type="email"
              placeholder="admin@areatrek.com"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrorMsg("");
              }}
              disabled={loading}
              autoComplete="email"
            />
          </div>

          {errorMsg && (
            <div
              style={{
                color: "#f5365c",
                fontSize: "12px",
                marginTop: "6px",
                fontWeight: "500",
              }}
            >
              <i className="fas fa-exclamation-circle mr-1"></i> {errorMsg}
            </div>
          )}
        </div>

        <Button
          className="sign-in-btn"
          type="submit"
          disabled={loading}
        >
          {loading ? (
            <>
              <i className="fas fa-spinner fa-spin mr-2 gradient-color-loader"></i>
              Sending Code...
            </>
          ) : (
            <>
              Send OTP Code
              <i className="fas fa-arrow-right ml-2"></i>
            </>
          )}
        </Button>

        <div className="text-center mt-4 pt-2">
          <a
            href="/auth/login"
            onClick={(e) => {
              e.preventDefault();
              navigate("/auth/login");
            }}
            style={{
              color: "#6b7280",
              fontSize: "0.85rem",
              fontWeight: "600",
              textDecoration: "none",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <i className="fas fa-arrow-left mr-2" style={{ fontSize: "0.75rem" }}></i> Back to Sign In
          </a>
        </div>
      </Form>
    </div>
  );
};

export default ForgotPassword;
